// Native (iOS/Android via Capacitor) shell. The web build imports this too; everything is a
// no-op there. Imported first in index.js so the start-route redirect happens before the
// pathname-based stylesheet choice below it.
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";

export const isNative = Capacitor.isNativePlatform();

// On the web the tenant is the page's origin (tenantMiddleware reads it on login). The app is
// served from capacitor://localhost / https://localhost, so the user names their company's web
// address once and login sends it as ?domain=. After login the JWT carries the domain.
const TENANT_KEY = "tenantDomain";

export const normalizeTenantDomain = input => {
  const host = String(input || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "");
  return host ? `https://${host}` : "";
};

export const getTenantDomain = () => localStorage.getItem(TENANT_KEY) || "";
export const setTenantDomain = domain => localStorage.setItem(TENANT_KEY, domain);

// Same role → area mapping the login page uses.
const homeForRole = role =>
  role === 3 ? "/subadmin" : role === 4 ? "/admin" : role === 0 ? "/client" : "/user";

if (isNative) {
  document.documentElement.classList.add("native-app");

  // "/" is the public marketing site; the app starts at the dashboard or the login.
  if (window.location.pathname === "/" || window.location.pathname === "") {
    let user = null;
    try {
      user = JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      // Unreadable stored user: treat as logged out.
    }
    const start = user && localStorage.getItem("token") ? homeForRole(user.role) : "/login";
    window.history.replaceState(null, "", start);
  }
}

export function initNativeShell() {
  if (!isNative) return;
  SplashScreen.hide();
  // Android hardware back: walk the router history, leave the app from its first screen.
  App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else App.exitApp();
  });
}
